<template>
  <Select v-model="locale" @update:model-value="handleLocaleChange">
    <SelectTrigger
      class="capitalize text-text-content font-medium text-sm w-32"
    >
      {{ locale }}
    </SelectTrigger>
    <SelectContent>
      <SelectGroup>
        <SelectItem
          v-for="(lang, localeLang) in langMap"
          :key="lang"
          :value="localeLang"
          class="cursor-pointer capitalize"
        >
          {{ localeLang }}
        </SelectItem>
      </SelectGroup>
    </SelectContent>
  </Select>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
} from "@/components/ui/select";
import { useRouter, useRoute } from "vue-router";
import { langMap, routeMap, getKeyByValue } from "@/util/dataProvider.js";

const { locale } = useI18n({});
const router = useRouter();
const route = useRoute();

const handleLocaleChange = (lang) => {
  // getting language key on the basis of language selected
  const langKey = getKeyByValue(routeMap, langMap[lang]);
  if (langKey === "en") {
    router.replace({ params: { lang: "" }, query: { ...route.query } });
  } else {
    router.replace({ params: { lang: langKey }, query: { ...route.query } });
  }
};
</script>
